export const ACTION_MODAL_ACTIONS = {
  SHOW_CONTACTOR_MODAL: 'showContactorsModal',
  SHOW_INVERTER_ROTATION_MODAL: 'showInverterRotationModal',
  SHOW_ROTATION_MODAL: 'showRotationModal',
  SHOW_EXTRACT_REPORT_MODAL: 'showExtractReportModal',
}
